import { render, staticRenderFns } from "./CAMessage.vue?vue&type=template&id=5f82e8ec&"
import script from "./CAMessage.vue?vue&type=script&lang=js&"
export * from "./CAMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports